import { getInjector } from '../../utils/getInjector';

export const onTrackGoCheckout = async (payload) => {
  const { items, subtotal } = payload;
  const injector = await getInjector();
  const Analytics = injector.get('Analytics');
  const gaService = injector.get('gaService');
  const trackerService = injector.get('trackerService');

  // General Event
  trackerService.track({
    type: trackerService.generalEventType.ADD_BILLING,
    data: {
      items,
      subtotal,
    },
  });

  trackerService.track({
    type: trackerService.generalEventType.ADD_SHIPPING,
    data: {
      items,
      subtotal,
    },
  });

  trackerService.track({
    type: trackerService.generalEventType.INITIATE_CHECKOUT,
    data: {
      items,
      subtotal,
    },
  });

  // Google Analysis
  if (Analytics.configuration.enhancedEcommerce) {
    gaService.setUserId();
    Analytics.trackCheckout(2, 'InitateCheckout');
    Analytics.trackEvent(
      'UX',
      'initate_checkout',
      'InitateCheckout',
      undefined,
      true,
    );
  }

  // Facebook Pixel
  trackerService.fbAddPaymentInfo(items, subtotal);
};
